import {Module} from "../index";
import {Sponsor} from "@/modules/sponsoring/entity/Sponsor";
import {GameCreationEventSubscriber} from "@/modules/sponsoring/subscribers/GameCreationEventSubscriber";
import SponsorFactory from "@/modules/sponsoring/services/SponsorFactory";
import messages from "./resources/messages";
import {routes} from "./resources/routes";
import SponsoringHandler from "@/modules/sponsoring/services/SponsoringHandler";
import {SponsoringEventSubscriber} from "@/modules/sponsoring/subscribers/SponsoringEventSubscriber";

export class SponsoringModule extends Module {
  messages = messages;
  routes = routes;

  public entities = [
    Sponsor,
  ];

  eventSubscribers = [
    GameCreationEventSubscriber,
    SponsoringEventSubscriber,
  ];


  protected register() {
    super.register();

    this.app.bind<SponsorFactory>(SponsorFactory).to(SponsorFactory);
    this.app.bind<SponsoringHandler>(SponsoringHandler).to(SponsoringHandler);
  }

  boot() {
    super.boot();
  }
}
